(function () {

    //bootstrap application
    MOVE.init();

}());



// WEBPACK FOOTER //
// ./app.js